import _ from 'lodash';

const env = process.env.REACT_APP_ENV;
console.log('*env', env)
const baseConfig = require('./config.base.json');
const envOverride = env ? require(`./config.${env}.json`) : require('./config.dev.json');

export default _.extend(baseConfig, envOverride);
